/** The landing page's clock (views/Landing.tsx): when the hall opens and closes, and the countdown. */

/** 1pm and 6pm on Sunday 18 October 2026, London time (BST, an hour ahead of UTC). */
export const OPENS = Date.UTC(2026, 9, 18, 12, 0, 0);
export const CLOSES = Date.UTC(2026, 9, 18, 17, 0, 0);

export type Stage = "before" | "on" | "after";

export function stageAt(now: number): Stage {
  if (now < OPENS) return "before";
  return now < CLOSES ? "on" : "after";
}

/** Days, hours, minutes and seconds left until `to`, none below zero. */
export function countdown(now: number, to: number): [number, number, number, number] {
  const s = Math.max(0, Math.floor((to - now) / 1000));
  return [Math.floor(s / 86400), Math.floor(s / 3600) % 24, Math.floor(s / 60) % 60, s % 60];
}
